<template>
  <div id="footer">
    <div class="container">
      <p>2022  Powered by <a href="/">Relbia Lodge</a></p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      
    };
  },
  created() {
          
      },
    methods:{
    }
};
</script>
<style scoped lang='less'>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 17px;
  background: #14171c;
  // font-family: 'Open Sans Bold';
  overflow: hidden;
  text-align: left;
  p {
    padding: 6px 0;
    margin: 8px 0;
    a {
    color: #fff;
    text-decoration: none;
  }
  }
}

@media screen and (max-width: 768px) {
  #footer {
    font-size: 16px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue